import styled from 'styled-components';
import React from 'react';
import media from 'client/styles/media';

import PaddingContainer from './PaddingContainer';
import FeatureRequest from './FeatureRequest';

const TeamSection = styled.section`
  position: relative;
  width: 100%;
  padding: 140px 0 140px;
  background: #fbf4ef;
  z-index: 1;
  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: -10px;
    right: 0;
    height: 20px;
    background: url('https://static.introwise.com/images/elements/main/intersect_orange.svg') top left repeat-x;
    z-index: -1;
  }
  .img-bg {
    display: none;
  }

  h2 {
    ${({ theme }) => theme.typography.h1};
    margin: 0 0 30px;
  }

  ${media.md} {
    padding: 70px 0 100px;
    ${PaddingContainer} {
      display: grid;
      grid-gap: 16px;
      grid-template-columns: repeat(12, 1fr);
      position: relative;
      z-index: 1;
    }

    h2 {
      grid-column: 1 / span 12;
    }
    .img-bg {
      display: block;
      position: absolute;
      right: 0;
      top: -10px;
      z-index: 0;
    }
  }
  ${media.lg} {
    background-image: url('https://static.introwise.com/images/elements/main/team_bg.svg');
    background-repeat: no-repeat;
    background-position: center 40px;
    h2 {
      grid-column: 2 / span 11;
    }
  }
`;

const TeamBlocks = styled.div`
  p {
    position: relative;
    margin: 0 0 34px;
    z-index: 0;
    img {
      position: absolute;
      top: 0;
      left: -45px;
      z-index: -1;
    }
    &:nth-child(even) {
      margin-left: 50px;
    }
  }
  .img-art {
    display: block;
    margin: 70px auto 30px;
  }

  ${media.sm} {
    p {
      width: 50%;
      padding-right: 30px;
      float: left;
      &:nth-child(even) {
        margin-left: 0;
        float: right;
      }
      img {
        top: 0;
        left: -15px;
      }
    }
  }
  ${media.md} {
    grid-column: 1 / span 7;
    .img-art {
      display: none;
    }
  }
  ${media.lg} {
    grid-column: 2 / span 6;
  }
`;
const TeamCol = styled.div`
  clear: both;
  p {
    margin: 0 0 10px;
  }
  .img-art {
    display: block;
    margin: 70px auto 25px;
  }
  ${media.md} {
    grid-column: 8 / span 5;
    .img-art {
      display: none;
    }
  }
  ${media.lg} {
    grid-column: 8 / span 4;
  }
`;
const FeedBack = styled.div`
  grid-column: 1 / span 12;
  &:after {
    content: '';
    display: block;
    height: 0;
    width: 100%;
    clear: both;
  }
  ${media.sm} {
    background: url(https://static.introwise.com/images/elements/main/pink_block.svg) no-repeat;
    background-size: 100% 100%;
    padding: 50px 30px 30px;
    display: grid;
    grid-gap: 16px;
    grid-template-columns: repeat(10, 1fr);
    ${({ theme }) => theme.typography.small};
    .col-left {
      grid-column: 1 / span 5;
    }
    .col-right {
      grid-column: 6 / span 5;
    }
  }
  ${media.md} {
    padding: 0 0 30px;
    margin-top: 0;
    .col-left {
      padding-left: 40px;
      margin-right: -20px;
      grid-column: 1 / span 3;
      order: 1;
    }
    .col-right {
      padding-left: 40px;
      margin-right: -20px;
      grid-column: 4 / span 3;
      order: 2;
    }
  }
  ${media.lg} {
    grid-column: 2 / span 10;
  }
`;

const FeedBackHeader = styled.div`
  background: url(https://static.introwise.com/images/elements/main/white_block.svg) no-repeat;
  background-size: 100% 100%;
  padding: 40px 20px;
  margin: 0 -20px 30px;
  h2 {
    margin: 0;
  }
  ${media.sm} {
    padding: 40px 30px;
    margin: 0 0 30px;
    grid-column: 1 / span 10;
  }
  ${media.md} {
    grid-column: 8 / span 3;
    order: 3;
    align-self: start;
    margin-right: 14px;
    margin-left: -30px h2 {
      font-size: 36px;
    }
  }
`;

const FeedPerson = styled.div`
  margin-bottom: 40px;
  p {
    margin: 0;
  }
  ${media.sm} {
    padding-right: 20px;
  }
  ${media.md} {
    margin-bottom: 40px;
    margin-top: 40px;
    padding-right: 0;
  }
`;
const FeedPersonInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 12px;
  .photo {
    display: block;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    margin-right: 12px;
  }
  h4 {
    margin: 0;
  }
  span {
    ${({ theme }) => theme.typography.small};
  }
`;
const FeedFeatureRequest = styled.div`
  display: none;
  ${media.md} {
    display: block;
    grid-column: 1 / span 12;
  }
  ${media.lg} {
    grid-column: 2 / span 10;
  }
`;

const CirclesArt = styled.div`
  img {
    display: none;

    &:nth-child(1) {
      display: block;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -100px;
    }
    &:nth-child(4) {
      display: block;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -100px;
      z-index: 5;
    }
  }
  ${media.md} {
    grid-column: 1 / span 12;
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;
    img {
      display: block;
      &:nth-child(1),
      &:nth-child(4) {
        position: static;
        transform: none;
      }
    }
  }
  ${media.lg} {
    grid-column: 2 / span 10;
    margin: 0 -16px 50px;
  }
`;

const Team = () => (
  <TeamSection>
    <img className="img-bg" src="https://static.introwise.com/images/elements/main/lines_art.svg" alt="" />
    <PaddingContainer>
      <CirclesArt>
        <img src="https://static.introwise.com/images/elements/main/circle_art_1.svg" alt="" />
        <img src="https://static.introwise.com/images/elements/main/circle_art_2.svg" alt="" />
        <img src="https://static.introwise.com/images/elements/main/circle_art_3.svg" alt="" />
        <img src="https://static.introwise.com/images/elements/main/circle_art_4.svg" alt="" />
      </CirclesArt>

      <h2>Introwise team</h2>
      <TeamBlocks>
        <p>
          <img src="https://static.introwise.com/images/elements/main/li_1.svg" alt="" />
          We are passionate about connecting people and building communities. Inclusive, open, and ready to have unique
          shared experiences.
        </p>
        <p>
          <img src="https://static.introwise.com/images/elements/main/li_2.svg" alt="" />
          We believe that participants are making events and communities great. The best connections come from sharing
          your passions and offering help first.
        </p>
        <p>
          <img src="https://static.introwise.com/images/elements/main/li_3.svg" alt="" />
          We want everyone to feel safe{' & '}welcomed. We fight harassment, discrimination and break the ice for you to
          feel like you are among friends.
        </p>
        <p>
          <img src="https://static.introwise.com/images/elements/main/li_4.svg" alt="" />
          World-leading engineering team. Our algorithms choose group chats based on your interests and adapt
          recommendations for the best unintentional connections.
        </p>

        <img className="img-art" src="https://static.introwise.com/images/elements/main/ract_art_1.svg" alt="" />
      </TeamBlocks>
      <TeamCol>
        <p>We&nbsp;helped organizing big events</p>
        <p>Each team member is&nbsp;an&nbsp;active community member</p>
        <p>Trusted by leading organizations making thousands of events</p>
        <p>
          We&nbsp;<span className="pink-highlight">listen to&nbsp;our customers</span> about their pains and feature
          requests
        </p>
        <p>We&nbsp;ship daily: updates and improvements</p>
        <p>
          <span className="pink-highlight">Helping you set everything up</span> and&nbsp;sharing engagement tips
        </p>
        <img className="img-art" src="https://static.introwise.com/images/elements/main/ract_art_2.svg" alt="" />
      </TeamCol>

      <FeedFeatureRequest>
        <FeatureRequest />
      </FeedFeatureRequest>

      <FeedBack>
        <FeedBackHeader>
          <h2>What are they saying about Introwise?</h2>
        </FeedBackHeader>
        <div className="col-left">
          <FeedPerson>
            <FeedPersonInfo>
              <img src="https://static.introwise.com/images/elements/main/feed_1.jpg" className="photo" alt="" />
              <div className="name">
                <h4>Elizabeth Panditescu</h4>
                <span>participant</span>
              </div>
            </FeedPersonInfo>
            <p>
              “Introwise does preparation for you. You’ll get more of the conference when you prepare in advance, but
              sometimes you have no time to go through all participants and reach out to them. You tell Introwise your
              interests and objectives, and they offer you groups to chat with relevant people and see who you want to
              meet.”
            </p>
          </FeedPerson>
          <FeedPerson>
            <FeedPersonInfo>
              <img src="https://static.introwise.com/images/elements/main/feed_2.jpg" className="photo" alt="" />
              <div className="name">
                <h4>Mary Changman</h4>
                <span>participant</span>
              </div>
            </FeedPersonInfo>
            <p>
              “At Introwise – all conversations in one place, structured by the topics. You don’t get lost in numerous
              channels on other platforms”.
            </p>
          </FeedPerson>

          <FeedPerson>
            <FeedPersonInfo>
              <img src="https://static.introwise.com/images/elements/main/feed_3.jpg" className="photo" alt="" />
              <div className="name">
                <h4>Carol Greenestein</h4>
                <span>participant</span>
              </div>
            </FeedPersonInfo>
            <p>
              “Introwise is more efficient in terms of preparation, planning all the event for you (where to live, what
              is the agenda, social meetings, professional meetings) and connecting to relevant people”
            </p>
          </FeedPerson>
          <FeedPerson>
            <FeedPersonInfo>
              <img src="https://static.introwise.com/images/elements/main/feed_4.jpg" className="photo" alt="" />
              <div className="name">
                <h4>John Chaisky</h4>
                <span>participant</span>
              </div>
            </FeedPersonInfo>
            <p>
              “Introwise brings more fun to the events. You connect with people to go for dinner or to go walk around
              the venue and talk around the subject of common interest”
            </p>
          </FeedPerson>
        </div>
        <div className="col-right">
          <FeedPerson>
            <FeedPersonInfo>
              <img src="https://static.introwise.com/images/elements/main/feed_5.jpg" className="photo" alt="" />
              <div className="name">
                <h4>Tom Dingleberg</h4>
                <span>participant</span>
              </div>
            </FeedPersonInfo>
            <p>
              “Introwise helps not to feel lonely at the events. I usually go by myself and don’t dare to start talking
              to others. But at Introwise I join group chats, and if the group feels interesting and nice, I meet with
              them”
            </p>
          </FeedPerson>
          <FeedPerson>
            <FeedPersonInfo>
              <img src="https://static.introwise.com/images/elements/main/feed_6.jpg" className="photo" alt="" />
              <div className="name">
                <h4>James Rosenthalberg</h4>
                <span>participant</span>
              </div>
            </FeedPersonInfo>
            <p>
              “Introwise lets you connect with cool people after the conference. Admit, you can{"'"}t talk to 150 people
              (during the event), so you can catch up and connect with them on the platform later”
            </p>
          </FeedPerson>

          <FeedPerson>
            <FeedPersonInfo>
              <img src="https://static.introwise.com/images/elements/main/feed_7.jpg" className="photo" alt="" />
              <div className="name">
                <h4>David Moidusen</h4>
                <span>participant</span>
              </div>
            </FeedPersonInfo>
            <p>
              “Other apps say they connect people – but are they really? We flew to the conference and sent 20 requests
              for the meetings at 1:1 matchmaking tool, and there was no answer. Zero. I wish they used Introwise at
              that event so I could connect with relevant people once the 1:1 matchmaking didn’t work out. But what
              happened is that it was just a waste of time and money.”
            </p>
          </FeedPerson>
        </div>
      </FeedBack>
    </PaddingContainer>
  </TeamSection>
);

export default Team;
